import React, { Component } from 'react';
import { BrowserRouter, Route, Redirect } from 'react-router-dom'
import { app, base } from './base'
import './App.css';
import ReactGA from 'react-ga';

import Loading from './components/utils/Loading';
import AdminHome from './components/admin/AdminHome'
import AdminLogin from './components/admin/AdminLogin'
import SetUpVoting from './components/admin/SetUpVoting'
import SetUpQuestions from './components/admin/SetUpQuestions'
import SetUpSessions from './components/admin/SetUpSessions'
import ManageSessions from './components/admin/ManageSessions'
import UserDynamicSessionScreen from './components/sessions/UserDynamicSessionScreen'
import SetUpCurrentSession from './components/admin/SetUpCurrentSession'
import CompanyVotesBigScreen from './components/creatorawards/CompanyVotesBigScreen'
import UserSessionScreen from './components/sessions/UserSessionScreen'
import Logout from './components/utils/Logout'
import UserScreenCreatorAwards from './components/creatorawards/UserScreenCreatorAwards'

if(process.env.NODE_ENV === "production"){
  ReactGA.initialize(process.env.REACT_APP_GA_KEY);
}

function AuthenticatedAdminRoute({component: Component, authenticated, ...rest}) {
    return (
        <Route
            {...rest}
            render={(props) => authenticated === true
                ? <Component {...props} {...rest} /> : <Redirect to={{pathname: '/admin/AdminLogin', state: {from: props.location}}} /> } />
    )
}

function logPageView() {
  if(process.env.NODE_ENV === "production"){
    ReactGA.set({ page: window.location.pathname })
    ReactGA.pageview(window.location.pathname)
  }
}

class App extends Component {
  constructor() {
        super()

        this.setCurrentUser = this.setCurrentUser.bind(this)
        this.state = {
            authenticated: false,
            currentUser: null,
            loading: true,
        }
    }

    setCurrentUser(user) {
        if (user) {
            this.setState({
                currentUser: user,
                authenticated: true
            })
        } else {
            this.setState({
                currentUser: null,
                authenticated: false
            })
        }
    }

    componentWillMount() {
        this.removeAuthListener = app.auth().onAuthStateChanged((user) => {
            if (user) {
                this.setState({
                    authenticated: true,
                    currentUser: user,
                    loading: false,
                })
            } else {
                this.setState({
                    authenticated: false,
                    currentUser: null,
                    loading: false,
                })
            }
        })
        this.connectedRef = base.bindToState(`.info/connected`, {
          context: this,
          state: 'connected',
        });
    }

    componentWillUnmount() {
        this.removeAuthListener(this.connectedRef);
    }




  render() {
    if (this.state.loading === true) {
        return (
            <Loading loading={this.state.loading}/>
        )
    }
    return (
      <div style={{ margin: "0 auto" }}>
                <BrowserRouter onUpdate={logPageView()}>
                    <div>
                        <div className="main-content">
                            <div className="workspace">
                              <Route
                                exact
                                path="/creatorscreen"
                                component={CompanyVotesBigScreen}
                                />
                              <Route
                                exact
                                path="/creatorvote"
                                render={(props) => {
                                    return <UserScreenCreatorAwards connection={this.state.connected} {...props} />
                                  }}
                                />
                              <Route
                                exact
                                path="/summitFB/session/:session_id"
                                render={(props) => {
                                    return <UserDynamicSessionScreen connection={this.state.connected} {...props} />
                                  }}
                                />
                              <Route
                                  exact
                                  path="/summitFB"
                                  render={(props) => {
                                      return <UserSessionScreen connection={this.state.connected} {...props} />
                                    }}
                                  />
                              <Route
                                exact
                                path="/admin/adminlogin"
                                user={this.state.currentUser}
                                render={(props) => {
                                  return <AdminLogin setCurrentUser={this.setCurrentUser} {...props} />
                                }} />

                              <AuthenticatedAdminRoute
                                  exact
                                  path="/admin/home"
                                  authenticated={this.state.authenticated}
                                  component={AdminHome} />

                              <AuthenticatedAdminRoute
                                  exact
                                  path="/admin/setupsessions"
                                  authenticated={this.state.authenticated}
                                  component={SetUpSessions} />
                                  
                              <AuthenticatedAdminRoute
                                  exact
                                  path="/admin/session/:session_id"
                                  authenticated={this.state.authenticated}
                                  component={ManageSessions} />

                              <AuthenticatedAdminRoute
                                  exact
                                  path="/admin/setupcurrentsession"
                                  authenticated={this.state.authenticated}
                                  component={SetUpCurrentSession} />

                              <AuthenticatedAdminRoute
                                  exact
                                  path="/admin/setupquestions"
                                  authenticated={this.state.authenticated}
                                  component={SetUpQuestions} />

                              <AuthenticatedAdminRoute
                                  exact
                                  path="/admin/setupvoting"
                                  authenticated={this.state.authenticated}
                                  component={SetUpVoting} />
                              <Route exact path="/logout" component={Logout} />
                            </div>
                        </div>
                    </div>
                </BrowserRouter>
            </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js